import { useState, useCallback } from "react";

/**
 * This is based on https://swizec.com/blog/usedimensions-a-react-hook-to-measure-dom-nodes/swizec/8983
 * we're not using useLayoutEffect because it doesn't give the correct width on initial render and the linter doesn't like mutable values in the dependency array
 * instead, we're using useCallback: https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
 */
export const useElementWidth = () => {
  const [width, setWidth] = useState();
  const ref = useCallback(
    node => {
      if (node !== null) {
        setWidth(node.getBoundingClientRect().width);
      }
    },
    // we want to get the width and not need to change it after the first time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [!!width]
  );
  return {
    ref,
    width,
  };
};
